import waitUntil from 'wait-until-promise';

const TIMEOUT_MS = 60000;
const INTERVAL_MS = 100;

export const waitForAmazonWidgetScript = () =>
  waitUntil(
    () => window.OffAmazonPayments != null && window.amazon != null,
    TIMEOUT_MS,
    INTERVAL_MS
  );
